// 📁 components/FullPageSection.jsx
"use client";
import React from "react";
import { useFullPageContext } from "@/context/FullPageContext";

export default function FullPageSection({
  index,
  id,
  label,
  transparent,
  hideDotNav,
  noCenter,
  children,
}: {
  index: number;
  id: string;
  label?: string;
  transparent?: boolean;
  hideDotNav?: boolean;
  noCenter?: boolean;
  children:
    | React.ReactNode
    | (({ isActive }: { isActive: boolean }) => React.ReactNode);
}) {
  const { activeIndex, isFullPage } = useFullPageContext();
  const isActive = activeIndex === index;
  const baseStyles: React.CSSProperties = isFullPage
    ? {
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: noCenter ? "flex-start" : "center",
        alignItems: noCenter ? "stretch" : "center",
        flexDirection: "column",
        position: "relative",
        transition: "opacity 0.6s ease, transform 0.6s ease",
        opacity: isActive ? 1 : 0.8, // Giữ hiện mờ nhẹ thay vì ẩn hẳn
        transform: isActive ? "translateY(0px)" : "translateY(20px)",
        backgroundColor: "transparent",
      }
    : {
        width: "100%",
        display: "block",
        boxSizing: "border-box",
      };

  return (
    <div
      id={id}
      style={baseStyles}
      data-snap-section
      data-index={index}
    >
      {typeof children === "function" ? children({ isActive }) : children}
    </div>
  );
}
